<giq-highlights *ngIf="showHighlights"></giq-highlights>
<giq-workspace></giq-workspace>
